/**
 * CalendarIcon — sanitized from `assets/newSvg/calendar.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function CalendarIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M16,3 C16.5523,3 17,3.44772 17,4 L17,5 L19,5 C20.0543909,5 20.9181678,5.81587733 20.9945144,6.85073759 L21,7 L21,19 C21,20.0543909 20.18415,20.9181678 19.1492661,20.9945144 L19,21 L5,21 C3.94563773,21 3.08183483,20.18415 3.00548573,19.1492661 L3,19 L3,7 C3,5.94563773 3.81587733,5.08183483 4.85073759,5.00548573 L5,5 L7,5 L7,4 C7,3.44772 7.44772,3 8,3 C8.55228,3 9,3.44772 9,4 L9,5 L15,5 L15,4 C15,3.44772 15.4477,3 16,3 Z M14.8241,9.37878 L10.5815,13.6214 L9.16727,12.2072 C8.77675,11.8167 8.14358,11.8167 7.75306,12.2072 C7.36253,12.5977 7.36253,13.2309 7.75306,13.6214 L9.86731,15.7357 C10.2617,16.1301 10.9012,16.1301 11.2957,15.7357 L16.2383,10.793 C16.6289,10.4025 16.6289,9.76931 16.2383,9.37878 C15.8478,8.98826 15.2146,8.98826 14.8241,9.37878 Z"
        fill={color}
      />
    </Svg>
  );
}

export default CalendarIcon;
